export const blockIconsHouseholdGrassNew = (
	<span className='material-symbols-outlined'>grass</span>
);
